export enum ResourcePermissionsEnum {
  picking = "picking",
  packingElocker = "packing-elocker",
  packingManual = "packing-manual",
  packingGroup = "packing-group",
  qrEntry = "qr-entry",
  qrExit = "qr-exit",
  qrCancel = "qr-cancel",
  printContGuides = "print-cont-guides",
  shipping = "shipping",
  shippingGroup = "shipping-group",
  printGuides = "print-guides",
  delivered = "delivered",
  deliveredReject = "sg_delivered_reject",
  deliveredSource = "delivered-transit-to-source",
  readyForPickupSource = "pickup-readyforpickup-source",
  pickupElocker = "pickup-elocker",
  pickupManual = "pickup-manual",
  cancelOrder = "cancel-order",
  qrEntryCancel = "qr-entry-cancel",
  qrExitCancel = "qr-exit-cancel",
  deliveredfinal = "delivered-final",
  deliveredfinal2 = "delivered-final-2",
  deliveredfinalcancel = "delivered-final-cancel",
  qrcancel2 = "qr-cancel-2",
  rejecProduct = "reject-product",
  cancelLogistic = "cancel-logistic",
  rejectOrder = "reject-order",
  rejectOrderDecrease = "reject-order-decrease",
  rejectedOrderStatus = "rejected-order-status",
  finalStatusCourier = "final-status-courier",
  hideConfirmActions = "hide-confirm-actions",
  hideDeliveryActions = "hide-delivery-actions",
  hidePackageActions = "hide-package-actions",
  hidePickupActions = "hide-pickup-actions",
  hideTransitActions = "hide-transit-actions",
  storeCd = "store-cd",
  orderPickupCancel = "order-pickup-cancel",
  orderClosedUploadFiles = "order-closed-upload-files",
  orderDeliveredUploadFiles = "order-closed-upload-files",
  sgDeleteFiles = "sg-delete-files",
  transitForReception = "status-in-transit-for-reception",
  in_source_preparation = "in-source-preparation",
  return_in_review = "status-return-in-review",
  confirmReceptionOpl = "confirm-reception-opl",
  transitForReceptionOpl = "status-in-transit-for-reception-opl",
  viewPickupCode = "view-pickup-code",
  createTROrder = "create-tr-order",
  editDataPickupCode = "edit-data-pickup-code",
  customerRejectOrderAction = "customer-reject-order-action",
  deliveredReturnOrderAction = "delivered-return-order-action",
  inReturnOrderState = "in-return-order-state",
  returnedOrderState = "returned-order-state",
  orderViewUploadFiles = "order-view-upload-files",
  sendDeliveryCode = "send-delivery-code",
  viewPickupCodePorta = "view-pickup-code-porta",
  qrPickupMail = "qr-pickup-mail",
  qrOnlyViewPickupMail = "qr-only-view-pickup-mail",
  reversaOrdersStatus = "preparation-reverse",
  showReversas = "show-reversas",
  searchOTChileexpress = "search-ot-chileexpress",
  viewOrderSearch = "view-order-search",
  viewTeamPerformanceMetric = "view-team-performance-metric",
}
